import { useNavigate } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { createStone } from "../../helpers/http_stones_requests";

export default function StoneNew() {

    const navigate = useNavigate();

    const formFieldList = [
        {
            title: "Informações da Pedra",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        createStone(data, () => navigate('/pedras'))
    };

    return <DynamicFormPage title={"Pedras - Cadastro"} onSubmit={handleSubmit} formFieldList={formFieldList} onCancel={() => navigate(-1)} />;

};
